import { StyleSheet, TextStyle } from 'react-native';
import { colors } from './../../theme/theme';

interface Styles {
  textInput: TextStyle;
}

const styles = StyleSheet.create<Styles>({
  textInput: {
    height: '100%',
    width: '100%',
    borderWidth: 1,
    textAlign: 'center',
    fontSize: 22,
    color: colors.yankeesBlue,
    borderColor: colors.gray25,
    borderRadius: 4,
  },
});

export default styles;
